import { DocumentationItemHeaderV2 } from "@supernova-studio/model";
import * as Y from "yjs";
import { z } from "zod";
import { DTODocumentationItemConfigurationV2 } from "../../api/dto/elements/documentation/item-configuration-v2";

//
// Types
//

export const DTODocumentationPageRoomHeaderData = z.object({
  title: z.string(),
  configuration: DTODocumentationItemConfigurationV2,
});

export const DTODocumentationPageRoomHeaderDataUpdate = z.object({
  title: z.string().optional(),
  configuration: DTODocumentationItemConfigurationV2.omit({ header: true })
    .extend({ header: DocumentationItemHeaderV2.partial() })
    .optional(),
});

export type DTODocumentationPageRoomHeaderData = z.infer<typeof DTODocumentationPageRoomHeaderData>;
export type DTODocumentationPageRoomHeaderDataUpdate = z.infer<typeof DTODocumentationPageRoomHeaderDataUpdate>;

//
// YJS Bindings
//

export function itemConfigurationToYjs(yDoc: Y.Doc, item: DTODocumentationPageRoomHeaderDataUpdate) {
  yDoc.transact(trx => {
    const { title, configuration } = item;

    const header = configuration?.header;

    if (title !== undefined) {
      const headerYMap = trx.doc.getMap("itemTitle");
      headerYMap.set("title", title);
    }

    if (header) {
      const headerYMap = trx.doc.getMap("itemHeader");

      header.description !== undefined && headerYMap.set("description", header.description);
      header.alignment !== undefined && headerYMap.set("alignment", header.alignment);
      header.foregroundColor !== undefined && headerYMap.set("foregroundColor", header.foregroundColor);
      header.backgroundColor !== undefined && headerYMap.set("backgroundColor", header.backgroundColor);
      header.backgroundImageAsset !== undefined && headerYMap.set("backgroundImageAsset", header.backgroundImageAsset);
      header.backgroundImageScaleType !== undefined &&
        headerYMap.set("backgroundImageScaleType", header.backgroundImageScaleType);
      header.showBackgroundOverlay !== undefined &&
        headerYMap.set("showBackgroundOverlay", header.showBackgroundOverlay);
      header.showCoverText !== undefined && headerYMap.set("showCoverText", header.showCoverText);
      header.minHeight !== undefined && headerYMap.set("minHeight", header.minHeight);
    }

    const configYMap = trx.doc.getMap("itemConfiguration");

    configuration?.showSidebar !== undefined && configYMap.set("showSidebar", configuration.showSidebar);
    configuration?.isHidden !== undefined && configYMap.set("isHidden", configuration.isHidden);
    configuration?.isPrivate !== undefined && configYMap.set("isPrivate", configuration.isPrivate);
  });
}
